import { Component, OnInit } from '@angular/core';

import { ModalPopupService } from 'src/app/shared/services/modal-popup.service';
import { PopupType } from 'src/app/model/modal-popup.model';
import { AgeVerificationDialogComponent } from 'src/app/shared/dialog/age-verification-dialog/age-verification-dialog.component';
import { TokenManagerService } from 'src/app/core/services/token-manager.service';
import { CookieService } from 'src/app/core/services/cookie.service';
import { CookieKey } from './shared/constants/config.constant';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'vape-ecommerce';
  ageVerificationDone: boolean;

  constructor(
    private modalPopupService: ModalPopupService,
    private tokenManagerService: TokenManagerService,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    this.ageVerificationDone = this.cookieService.getCookie(CookieKey.AgrVerification) === 'true' ? true : false;
    if (this.tokenManagerService.appConfiguration.AgeVerification && !this.ageVerificationDone) {
      const modalPopupRef = this.modalPopupService.showModal(
        {
          type: PopupType.CUSTOM,
        }, AgeVerificationDialogComponent);
    }
  }
}
